<template>
  <el-container class="admin-container">
    <!-- 桌面端侧边栏 -->
    <el-aside width="200px" class="desktop-aside">
      <el-menu
        :default-active="activeMenu"
        class="admin-menu"
        @select="handleSelect"
      >
        <el-menu-item index="">
          <el-icon><Monitor /></el-icon>
          <span>控制台[未开放]</span>
        </el-menu-item>
        
        <el-menu-item index="/admin/site">
          <el-icon><Edit /></el-icon>
          <span>网站内容</span>
        </el-menu-item>

        <el-menu-item index="/admin/products">
          <el-icon><Goods /></el-icon>
          <span>产品管理</span>
        </el-menu-item>
        
        <el-menu-item index="/admin/categories">
          <el-icon><Files /></el-icon>
          <span>分类管理</span>
        </el-menu-item>
        
        <el-menu-item index="/admin/banners">
          <el-icon><Picture /></el-icon>
          <span>轮播图管理</span>
        </el-menu-item>
        
        <el-menu-item index="/admin/contents">
          <el-icon><Document /></el-icon>
          <span>内容管理</span>
        </el-menu-item>
        
        <el-menu-item index="/admin/messages">
          <el-icon><ChatLineSquare /></el-icon>
          <span>留言管理</span>
        </el-menu-item>
        
        <el-menu-item index="/admin/news">
          <el-icon><Reading /></el-icon>
          <span>新闻管理</span>
        </el-menu-item>
        
        <el-menu-item index="">
          <!-- /admin/images -->
          <el-icon><PictureFilled /></el-icon>
          <span>图片管理[未开放]</span>
        </el-menu-item>
      </el-menu>
    </el-aside>
    
    <!-- 移动端顶部导航 -->
    <div class="mobile-admin-header">
      <div class="mobile-header-left">
        <el-dropdown trigger="click" @command="handleSelect" class="mobile-menu-dropdown">
          <span class="mobile-menu-trigger">
            <svg viewBox="0 0 24 24" width="24" height="24">
              <path fill="currentColor" d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"/>
            </svg>
          </span>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item command="/admin/site">
                <svg viewBox="0 0 24 24" width="16" height="16" class="menu-icon">
                  <path fill="currentColor" d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"/>
                </svg>
                网站内容
              </el-dropdown-item>
              <el-dropdown-item command="/admin/products">
                <svg viewBox="0 0 24 24" width="16" height="16" class="menu-icon">
                  <path fill="currentColor" d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"/>
                </svg>
                产品管理
              </el-dropdown-item>
              <el-dropdown-item command="/admin/categories">
                <svg viewBox="0 0 24 24" width="16" height="16" class="menu-icon">
                  <path fill="currentColor" d="M10 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2h-8l-2-2z"/>
                </svg>
                分类管理
              </el-dropdown-item>
              <el-dropdown-item command="/admin/banners">
                <svg viewBox="0 0 24 24" width="16" height="16" class="menu-icon">
                  <path fill="currentColor" d="M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0-2-.9-2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z"/>
                </svg>
                轮播图管理
              </el-dropdown-item>
              <el-dropdown-item command="/admin/contents">
                <svg viewBox="0 0 24 24" width="16" height="16" class="menu-icon">
                  <path fill="currentColor" d="M14 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V8l-6-6zM6 20V4h7v5h5v11H6z"/>
                </svg>
                内容管理
              </el-dropdown-item>
              <el-dropdown-item command="/admin/messages">
                <svg viewBox="0 0 24 24" width="16" height="16" class="menu-icon">
                  <path fill="currentColor" d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H6l-2 2V4h16v12z"/>
                </svg>
                留言管理
              </el-dropdown-item>
              <el-dropdown-item command="/admin/news">
                <svg viewBox="0 0 24 24" width="16" height="16" class="menu-icon">
                  <path fill="currentColor" d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z"/>
                </svg>
                新闻管理
              </el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div>
      <h2 class="mobile-title">后台管理系统</h2>
      <div class="mobile-header-right">
        <el-dropdown @command="handleCommand">
          <span class="mobile-user">
            <svg viewBox="0 0 24 24" width="24" height="24">
              <path fill="currentColor" d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
            </svg>
          </span>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item command="logout">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div>
    </div>

    <el-container class="main-container">
      <el-main>
        <router-view></router-view>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { 
  Goods, 
  Files, 
  Picture, 
  Document, 
  PictureFilled,
  ArrowDown,
  ChatLineSquare,
  Reading,
  Monitor,
  Edit
} from '@element-plus/icons-vue'
import { ElMessageBox, ElMessage } from 'element-plus'
import request from '@/utils/request'

export default {
  name: 'AdminLayout',
  components: {
    Goods,
    Files,
    Picture,
    Document,
    PictureFilled,
    ArrowDown,
    ChatLineSquare,
    Reading,
    Monitor,
    Edit
  },
  setup() {
    const route = useRoute()
    const router = useRouter()
    
    const activeMenu = computed(() => route.path)
    
    const handleSelect = (key) => {
      router.push(key)
    }
    
    const handleCommand = async (command) => {
      if (command === 'logout') {
        try {
          await ElMessageBox.confirm('确定要退出登录吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          
          localStorage.removeItem('token')
          localStorage.removeItem('username')
          
          ElMessage.success('退出成功')
          router.push('/admin/login')
        } catch (error) {
          if (error !== 'cancel') {
            console.error('退出失败:', error)
            ElMessage.error('退出失败')
          }
        }
      }
    }
    
    return {
      activeMenu,
      handleSelect,
      handleCommand
    }
  }
}
</script>

<style scoped>
.admin-container {
  height: 100vh;
}

.el-aside {
  background-color: #304156;
}

.admin-menu {
  height: 100%;
  background-color: #304156;
}

:deep(.el-menu) {
  border-right: none;
}

:deep(.el-menu-item) {
  color: #bfcbd9;
}

:deep(.el-menu-item.is-active) {
  color: #409eff;
  background-color: #263445;
}

.el-header {
  background-color: #fff;
  border-bottom: 1px solid #dcdfe6;
  padding: 0 20px;
}

.header-content {
  height: 60px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.admin-dropdown {
  cursor: pointer;
  color: #666;
}

.el-main {
  background-color: #f0f2f5;
  padding: 20px;
}

.mobile-admin-header {
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 56px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  z-index: 1000;
  padding: 0 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.mobile-menu-dropdown {
  position: relative;
  z-index: 1001;
}

.mobile-menu-trigger,
.mobile-user {
  cursor: pointer;
  padding: 8px;
  color: #606266;
  display: flex;
  align-items: center;
}

.mobile-title {
  font-size: 16px;
  color: #303133;
  margin: 0;
  flex: 1;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 0 10px;
}

.menu-icon {
  margin-right: 8px;
  vertical-align: -3px;
}

.main-container {
  margin-top: 56px;
}

@media (max-width: 768px) {
  .admin-container {
    height: 100vh;
    overflow: hidden;
  }

  .desktop-aside {
    display: none;
  }

  .mobile-admin-header {
    display: flex;
  }

  .main-container {
    padding-top: 56px;
    height: calc(100vh - 56px);
    overflow-y: auto;
  }

  .el-main {
    padding: 16px;
    min-height: calc(100vh - 56px);
  }

  /* 表格适配 */
  :deep(.el-table) {
    width: 100% !important;
    font-size: 14px;
  }

  :deep(.el-table__header),
  :deep(.el-table__body) {
    width: 100% !important;
  }

  :deep(.el-table .cell) {
    padding: 8px;
    white-space: normal;
    word-break: break-all;
  }

  :deep(.el-table .el-button) {
    padding: 6px 12px;
    font-size: 12px;
  }

  /* 表单适配 */
  :deep(.el-form-item) {
    margin-bottom: 16px;
  }

  :deep(.el-form-item__label) {
    float: none;
    display: block;
    text-align: left;
    padding: 0 0 8px;
    line-height: 1.5;
    font-size: 14px;
  }

  :deep(.el-form-item__content) {
    margin-left: 0 !important;
  }

  :deep(.el-input__inner) {
    height: 36px;
  }

  :deep(.el-textarea__inner) {
    min-height: 80px;
  }

  /* 按钮适配 */
  :deep(.el-button) {
    padding: 8px 16px;
    font-size: 14px;
  }

  /* 分页器适配 */
  :deep(.el-pagination) {
    padding: 16px 0;
    justify-content: center;
    white-space: normal;
    flex-wrap: wrap;
  }

  :deep(.el-pagination .el-select .el-input) {
    width: 90px;
  }

  /* 弹窗适配 */
  :deep(.el-dialog) {
    width: 90% !important;
    margin: 0 auto !important;
  }

  :deep(.el-dialog__body) {
    padding: 16px !important;
    max-height: 70vh;
    overflow-y: auto;
  }

  /* 下拉菜单适配 */
  :deep(.el-dropdown-menu) {
    max-width: 90vw;
  }

  :deep(.el-dropdown-menu__item) {
    padding: 8px 16px;
    font-size: 14px;
    line-height: 1.5;
  }
}
</style> 